import { LoanDocState, TaskState } from 'gql/graphql';
import { Phases } from '../../LoanPhase.constanst';
import { getTaskIcon } from './processorPhaseStates';
import { RulesTasksCards } from '../../RulesTask.constanst';

export const processBorrowerTaskItems = (
  _phase: any,
  loanDocs: any[],
  loan: any,
  tasks: any[]
) => {
  // Lógica original de getTasks() del processing
  const newTasks = tasks?.filter(task => !task.key);
  newTasks?.map((newTask: any) => {
    let isCard = RulesTasksCards.find(item => item.key === newTask._id);
    let _newTask = {
      key: newTask._id,
      modalKey: newTask._id,
      name: newTask.name,
      data: newTask,
      phaseProgress: newTask?.phase,
      state: newTask?.state
    };

    if (!isCard)
      RulesTasksCards.push(_newTask as any);
    else
      isCard.state = _newTask.state;
  });

  for (const rules of RulesTasksCards) {
    const findTask = tasks?.filter(item => item.state !== undefined).find(item => item?.key === rules.key);
    const findTaskNew = tasks?.filter(item => !item.hidden).find(item => item?._id === rules.key);
    if (findTask || findTaskNew) {
      if (findTask) {
        rules.data = findTask;
        rules.state = rules.state !== TaskState.Approved ? findTask?.state : rules.state;
      }
      if (findTaskNew) {
        rules.data = findTaskNew;
        rules.state = rules.state !== TaskState.Approved ? findTaskNew?.state : rules.state;
      }
    }
  }

  const rulesTasksCardsNotHidden = RulesTasksCards.filter(item => !item.data?.hidden && item.state !== undefined);

  // Procesar borrower items task para la fase específica (lógica original processing)
  const filteredRulesTaskCards = rulesTasksCardsNotHidden.filter(item => 
    item.phaseProgress === _phase.key as Phases &&
    (!item.loanType || item.loanType?.includes(loan?.type)) &&
    (!item.loanPurposes || item.loanPurposes?.includes(loan?.purpose))
  );

  rulesTasksCardsNotHidden.forEach((taskCard, index) => {
    if (
      taskCard.phaseProgress === _phase.key as Phases &&
      (!taskCard.loanType || taskCard.loanType?.includes(loan.type)) &&
      (!taskCard.loanPurposes || taskCard.loanPurposes?.includes(loan?.purpose))
    ) {
      const buttonState = taskCard.progressButtons && taskCard.state !== undefined
        ? taskCard.progressButtons[taskCard.state]
        : undefined;

      const loanDocBlocked = loanDocs?.find(item =>
        item.state === LoanDocState.Blocking &&
        taskCard.state !== TaskState.Approved &&
        taskCard.state !== TaskState.Review &&
        taskCard.key.includes(item.key)
      );

      const loanDocRef = loanDocs?.find(item =>
        taskCard.key.includes(item.key) &&
        item.file?.url &&
        !item.hidden
      );

      // Crear el item task de borrower (lógica original processing)
      _phase.tasksItems.push({
        id: index,
        key: taskCard.key,
        modalKey: taskCard.modalKey,
        icon: getTaskIcon(taskCard.state ?? '', _phase.state),
        text: taskCard.name,
        titleButton: (buttonState ? buttonState.label : 'View'),
        state: loanDocBlocked ? 'BLOCKED' : taskCard.state,
        loanDoc: loanDocRef
      });
    }
  });

  return filteredRulesTaskCards;
};